import React, { useEffect, useMemo, useRef, useState } from 'react'
import HeaderHLPure from '../headerHL/headerHL.pure'
import { Grid } from '@material-ui/core'
import LabelPure from '../label/label.pure'
import { DropDownList, MultiColumnComboBox } from '@progress/kendo-react-dropdowns'
import ButtonHLPure from '../buttonHL/buttonHL.pure'
import SearchBarHLPure from '../searchBarHL/searchBarHL.pure'
import GridPure from '../gridHL/grid.pure'
import { handleSelectedElements } from "../../../utils";
import { SelectAllIcon } from "../../../assets/logos/icons";
import { filterBy } from "@progress/kendo-data-query";

const SelectBranchOffices = (props) => {
  const {
    allBranchOffices,
    branchOfficesSelected,
    setBranchOfficesSelected,
    t
  } = props;

  const [branchOfficesOptions, setBranchOfficesOptions] = useState(allBranchOffices)
  const [loading, setLoading] = useState(false);
  const timeout = useRef();

  // Country selection
  const [selectedCountry, setSelectedCountry] = useState()
  const countryOptions = useMemo(() => {
    if (!allBranchOffices || !allBranchOffices.length) return;
    const countries = new Set();
    allBranchOffices.forEach(item => countries.add(item.country));
    return [...countries].sort((a, b) => a.localeCompare(b))
  }, [allBranchOffices])

  useEffect(() => {
    if (countryOptions && countryOptions.length > 0) {
      setSelectedCountry(countryOptions[0])
    }
  }, [countryOptions])

  const handleChangeCountry = (value) => setSelectedCountry(value)

  // Branch office selection
  const handleOptionsFilterChange = (event) => filterOptions(selectedCountry, event.filter?.value || "")

  const filterOptions = (country, searchText = "") => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    const filter = {
      logic: "and",
      filters: [
        {
          field: "country",
          operator: "eq",
          value: country,
          ignoreCase: true,
        },
        {
          logic: "or",
          filters: [
            { field: "name", operator: "contains", value: searchText, ignoreCase: true },
            { field: "city", operator: "contains", value: searchText, ignoreCase: true },
            { field: "keyIdentifier", operator: "contains", value: searchText, ignoreCase: true },
          ],
        },
      ],
    }

    timeout.current = setTimeout(() => {
      setBranchOfficesOptions(applyFilter(filter));
      setLoading(false);
    }, 500);
    setLoading(true);
  }

  const applyFilter = (filter) => {
    // quita las que ya están seleccionadas
    const localData = allBranchOffices.filter((item) => {
      if (!branchOfficesSelected.some(branch => branch.id === item.id)) return item
    })

    return filterBy(localData, filter)
  }

  const selectAll = () => {
    setBranchOfficesSelected([...branchOfficesSelected, ...branchOfficesOptions])
  }

  useEffect(() => {
    filterOptions(selectedCountry)
  }, [selectedCountry, branchOfficesSelected])

  // Search selected branch offices
  const [searchText, setSearchText] = useState("")
  const branchOfficesSelectedDisplayed = useMemo(() => {
    const lowercaseSearchText = searchText.toLowerCase();
    return branchOfficesSelected.filter(item => {
      return item.name.toLowerCase().includes(lowercaseSearchText) || item.keyIdentifier.toLowerCase().includes(lowercaseSearchText)
    });
  }, [searchText, branchOfficesSelected])

  const deleteBranchOfficesList = (deleteBranchOffice) => {
    setBranchOfficesSelected(branchOfficesSelected.filter((branchOffice) => branchOffice.id !== deleteBranchOffice.id))
  }

  return <>
    <Grid item xs={12} style={{ marginTop: 16 }}>
      <HeaderHLPure headingNumber={3} title={t("publicityView.addPublicityBranchOffice")} />
    </Grid>

    <Grid item xs={12} md={3}>
      <LabelPure title={t("publicityView.country")} editorId="country" />
      <DropDownList
        id="country"
        className="eticket-dropdown-field"
        style={{ marginBottom: 0 }}
        data={countryOptions}
        onChange={(e) => handleChangeCountry(e.target.value)}
        value={selectedCountry}
      />
    </Grid>

    <Grid item xs={12} md={9}>
      <LabelPure title={t("publicityView.branches")} editorId="branch-offices" />
      <div style={{ display: "grid", gridTemplateColumns: '1fr auto', gap: 8 }}>
        <MultiColumnComboBox
          id='branch-offices'
          data={branchOfficesOptions}
          columns={[
            {
              field: "keyIdentifier",
              header: t("publicityView.keyIdentifier"),
              width: "100px",
            },
            {
              field: "name",
              header: t("publicityView.name"),
              width: "300px",
            },
            {
              field: "city",
              header: t("publicityView.city"),
              width: "300px",
            },
          ]}
          textField={"name"}
          filterable={true}
          onFilterChange={handleOptionsFilterChange}
          onChange={(event) => handleSelectedElements(event, branchOfficesSelected, setBranchOfficesSelected, allBranchOffices, setBranchOfficesOptions)}
          onClose={handleOptionsFilterChange}
          loading={loading}
          placeholder={t("selectOption")}
          value={null}
        />
        <ButtonHLPure colorScheme="neutral" nameBtn={<img src={SelectAllIcon} />} title={t("publicityView.selectAllBranches")} onClick={selectAll} />
      </div>
    </Grid>

    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", paddingTop: 24 }}>
      <SearchBarHLPure placeholder={t("publicityView.addPublicitySearchBranchOffice")} onSearchChange={(e) => setSearchText(e.target.value)} searchValue={searchText} />
    </Grid>

    <Grid item xs={12}>
      <GridPure
        {...props}
        dataGrid={branchOfficesSelectedDisplayed}
        skip={0}
        take={11}
        rowsItems={[{
          field: 'keyIdentifier',
          title: t("publicityView.addPublicityColumnKeyIdentifier"),
          width: '20%'
        },
        {
          field: 'name',
          title: t("publicityView.addPublicityColumnName"),
          width: '40%'
        },
        {
          field: 'Acciones',
          title: t("publicityView.addPublicityColumnActions"),
          width: '15%',
          actions: true,
        }]}
        iconOneActive
        labelOneActions={t("configurationPanelView.delete.domain.btn")}
        activeDialog1
        styleCol1={"configurationDomainsView-style-col-1"}
        labelsColumnsNoPadding={false}
        actions={[
          {
            type: 'icon',
            value: 'k-icon k-i-delete k-i-trash',
            onClick: (dataItem) => { deleteBranchOfficesList(dataItem) }
          },
        ]}
      />
    </Grid>
  </>
}

export default SelectBranchOffices